import { Button } from "@/components/flexkit/Button";
import { cn } from "@/components/podkit/lib/cn";
import { Text } from "@/components/podkit/typography/Text";
import type { FC, ReactNode } from "react";

export type SuperOnaEmptyStateAction = {
    label: string;
    onClick: () => void;
    loading?: boolean;
    trackingId?: string;
};

export type SuperOnaEmptyStateProps = {
    icon: ReactNode;
    message: string;
    action?: SuperOnaEmptyStateAction;
    className?: string;
};

export const SuperOnaEmptyState: FC<SuperOnaEmptyStateProps> = ({ icon, message, action, className }) => {
    return (
        <div className={cn("flex flex-1 flex-col items-center justify-center", className)}>
            <div className="flex flex-col items-center gap-2 text-center">
                {icon}
                <Text className="text-content-tertiary">{message}</Text>
                {action && (
                    <Button
                        variant="secondary"
                        size="sm"
                        onClick={action.onClick}
                        loading={action.loading}
                        data-tracking-id={action.trackingId}
                    >
                        {action.label}
                    </Button>
                )}
            </div>
        </div>
    );
};
